import LegalPage, { Section } from "../LegalPage";

function Regulamin() {
  return (
    <LegalPage
      tag="Regulamin"
      title="Regulamin świadczenia usług na platformie Notaup.pl"
      subtitle="Dowiedz się, jak postępujemy z Twoimi danymi osobowymi i dbamy o Twoją prywatność i bezpieczeństwo danych na naszej platformie."
      lastUpdated="31 grudnia 2024 r."
    >
      <Section title="Postanowienia ogólne">
        <ol>
          <li>
            Regulamin świadczenia usług na platformie Notaup.pl, zwany dalej
            „Regulaminem", określa:
            <ol>
              <li>warunki świadczenia usług;</li>
              <li>zasady wykonywania usług;</li>
              <li>
                sposób postępowania w przypadku niewykonania lub nienależytego
                wykonania usług;
              </li>
              <li>
                wysokość, tryb i sposób wypłaty odszkodowań w przypadku
                niewykonania lub nienależytego wykonania usług;
              </li>
            </ol>
          </li>
          <li>Regulamin dotyczy usług udostępnianych na platformie Notaup.pl.</li>
          <li>
            Głównym dostawcą usług, o których mowa w ust. 1, jest KFJ Inwestycje
            Sp. z o.o. zwana dalej: „KFJ", z siedzibą w Sopocie (81-807) przy
            ulicy 1 Maja 5, zarejestrowana pod numerem KRS 0000048362, NIP
            5832534157, REGON 191560660 o kapitale zakładowym 856 600,00 zł.
          </li>
          <li>
            Na platformie Notaup.pl są udostępniane usługi innych podmiotów
            publicznych i niepublicznych, a w szczególności są to usługi
            związane z obsługą przesyłek przekazywanych jako doręczenia
            elektroniczne.
          </li>
          <li>
            Regulamin jest napisany w zrozumiałym języku i jest umieszczony w
            repozytorium, które jest publicznie dostępne pod adresem Notaup.pl.
          </li>
          <li>
            Wszystkie informacje publikowane w repozytorium są ogólnie dostępne.
            Informacje te są zabezpieczone przed nieautoryzowanym zmienianiem.
          </li>
        </ol>
      </Section>

      <Section title="Słownik pojęć użytych w Regulaminie">
        <ol>
          <li>
            <strong>Adres do doręczeń elektronicznych (ADE)</strong> – adres
            elektroniczny, o którym mowa w art. 2 pkt 1 ustawy z dnia 18 lipca
            2002 r. o świadczeniu usług drogą elektroniczną (Dz. U. z 2020 r.
            poz. 344), podmiotu korzystającego z publicznej usługi
            rejestrowanego doręczenia elektronicznego lub publicznej usługi
            hybrydowej albo z kwalifikowanej usługi rejestrowanego doręczenia
            elektronicznego, umożliwiający jednoznaczną identyfikację nadawcy
            lub adresata danych przesyłanych w ramach tych usług;
          </li>
          <li>
            <strong>Adresat</strong> – podmiot określony przez nadawcę jako
            odbiorca przesyłki;
          </li>
          <li>
            <strong>API</strong> – usługa sieciowa, która umożliwia wymianę
            informacji między systemem KURDE a systemem kancelaryjnym podmiotu;
          </li>
          <li>
            <strong>BAE</strong> – baza adresów elektronicznych, będąca
            rejestrem publicznym, w którym gromadzone są adresy do doręczeń
            elektronicznych, prowadzonym przez ministra właściwego do spraw
            informatyzacji;
          </li>
          <li>
            <strong>Dane identyfikujące osobę</strong> – zestaw danych
            umożliwiających ustalenie tożsamości Klienta;
          </li>
          <li>
            <strong>Dostawcy usług Notaup.pl</strong> – podmioty wymienione w
            pkt. 1.4
          </li>
          <li>
            <strong>Dostawca usług zaufania</strong> – dostawca usługi zaufania
            będący osobą fizyczną lub prawną, która świadczy przynajmniej jedną
            usługę zaufania, jako kwalifikowany lub niekwalifikowany dostawca
            usług zaufania;
          </li>
          <li>
            <strong>Dyrektor KFJ</strong> – Dyrektor KFJ Inwestycje Sp. z o.o.
          </li>
          <li>
            <strong>Dysk szyfrowany Nota</strong> – usługa polegająca na
            przechowywaniu w chmurze plików, oraz udostępnieniu oprogramowania
            obsługującego szyfrowanie tych plików w trybie szyfrowania
            end-to-end
          </li>
          <li>
            <strong>Doręczenie elektroniczne</strong> – doręczenie przesyłki za
            pośrednictwem systemu KURDE na ADE adresata;
          </li>
          <li>
            <strong>EZD Nota</strong> – oprogramowanie służące do
            elektronicznego zarządzania dokumentami udostępniane na platformie
            Notaup.pl w modelu SaaS
          </li>
          <li>
            <strong>KFJ</strong> – KFJ Inwestycje Sp. z o.o., będąca
            kwalifikowanym dostawcą usług zaufania świadczącym kwalifikowaną
            usługę rejestrowanego doręczenia elektronicznego, o której mowa w
            art. 3 pkt 37 rozporządzenia 910/2014;
          </li>
          <li>
            <strong>Klient</strong> – podmiot, którego łączy z KFJ umowa na
            świadczenie kwalifikowanej usługi rejestrowanych doręczeń
            elektronicznych (KURDE), zgodnie z § 3 ust. 1 Regulaminu;
          </li>
          <li>
            <strong>KURDE</strong> – kwalifikowana usługa rejestrowanego
            doręczenia elektronicznego jako usługa rejestrowanego doręczenia
            elektronicznego, o której mowa w art. 3 pkt 37 Rozporządzenia
            eIDAS;
          </li>
          <li>
            <strong>Kwalifikowany dostawca usług zaufania</strong> – dostawca
            usług zaufania, który uzyskał status kwalifikowany po
            zweryfikowaniu sposobu wykonywania usługi zaufania przez
            certyfikowanego audytora oraz po akceptacji wyników audytu przez
            Organ Nadzoru;
          </li>
          <li>
            <strong>Multi skrzynka Nota</strong> – usługa dostępna na
            platformie Notaup.pl umożliwiająca odbieranie i wysyłanie przesyłek
            elektronicznych z wykorzystaniem takich kanałów komunikacji
            elektronicznej jak:
            <ol type="a">
              <li>E-mail</li>
              <li>Doręczenia elektroniczne obsługiwane zgodnie z UoDE</li>
              <li>
                Doręczenie poprzez Portal Informacyjny Sądów Powszechnych
              </li>
              <li>Poczta Nota obsługująca przesyłki szyfrowane Nota</li>
              <li>Inne kanały w miarę ich integrowania z multi skrzynka Nota</li>
            </ol>
          </li>
          <li>
            <strong>Notyfikacja</strong> – zdefiniowane zdarzenie powodujące
            uruchomienie procesu dostarczenia predefiniowanych komunikatów za
            pośrednictwem obsługiwanych kanałów komunikacyjnych, innych niż
            przesyłka w ramach realizacji KURDE, z uwzględnieniem preferencji i
            zgód ich odbiorców;
          </li>
          <li>
            <strong>Personel KFJ</strong> – osoby współpracujące z KFJ podczas
            utrzymania, konserwacji oraz rozwoju platformy Notaup.pl, w tym
            osoby zatrudnione na podstawie umowy o pracę oraz osoby fizyczne
            świadczące osobiście usługi na rzecz KFJ w oparciu o umowę o dzieło,
            umowę zlecenia, umowę o świadczenie usług;
          </li>
          <li>
            <strong>Poczta Nota</strong> – kanał komunikacji elektronicznej
            obsługujący przesyłki szyfrowane Nota
          </li>
          <li>
            <strong>Podmiot niepubliczny</strong> – osoba fizyczna i podmiot
            inny niż podmiot publiczny;
          </li>
          <li>
            <strong>Podmiot publiczny</strong>:
            <ol type="a">
              <li>
                jednostka sektora finansów publicznych w rozumieniu przepisów
                ustawy z dnia 27 sierpnia 2009 r. o finansach publicznych (Dz.
                U. z 2021 r. poz. 305),
              </li>
              <li>
                inne niż określone w lit. a państwowe jednostki organizacyjne
                nieposiadające osobowości prawnej,
              </li>
              <li>
                inne niż określone w lit. a osoby prawne utworzone w
                szczególnym celu zaspokajania potrzeb o charakterze
                powszechnym, niemające charakteru przemysłowego ani
                handlowego,
              </li>
              <li>
                związki podmiotów, o których mowa w lit. a–c, jeżeli realizują
                zadania publiczne,
              </li>
              <li>komornik sądowy;</li>
            </ol>
          </li>
          <li>
            <strong>Polityka świadczenia usługi KURDE</strong> – Polityka
            świadczenia usługi dla kwalifikowanej usługi rejestrowanego
            doręczenia elektronicznego w KFJ Inwestycje Sp. z o.o., dostępna na
            stronie internetowej doreczeniaelektroniczne.pl;
          </li>
          <li>
            <strong>
              Przesyłka typu doręczenie elektroniczne [przesyłka DE]
            </strong>{" "}
            – dane przesyłane pomiędzy stronami z wykorzystaniem usługi KURDE;
          </li>
          <li>
            <strong>Przesyłka szyfrowana Nota [przesyłka Nota]</strong> – dane
            przekazywane poprzez Pocztę Nota
          </li>
          <li>
            <strong>Regulamin</strong> – Regulamin świadczenia usług na
            platformie Notaup.pl, dostępny na stronie internetowej notaup.pl;
          </li>
          <li>
            <strong>RODO</strong> – Rozporządzenie Parlamentu Europejskiego i
            Rady (UE) 2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób
            fizycznych w związku z przetwarzaniem danych osobowych i w sprawie
            swobodnego przepływu takich danych oraz uchylenia dyrektywy
            95/46/WE;
          </li>
          <li>
            <strong>Rozszerzenia Nota</strong> – oprogramowanie rozbudowujące
            możliwości funkcjonalne platformy Notaup.pl udostępniane w modelu
            SaaS
          </li>
          <li>
            <strong>Szyfrowanie end-to-end</strong> – procedura szyfrowania
            stosowana podczas wysyłania danych do serwerów chmurowych.
            Procedura polega na szyfrowaniu danych przed ich wysłaniem,
            utrzymywania w stanie zaszyfrowanym podczas składowania danych na
            serwerze chmurowym i ponownym rozszyfrowywaniu dopiero gdy dane
            zostaną przesłane na komputer osoby uprawnionej do ich odczytu.
          </li>
          <li>
            <strong>UoDE</strong> – ustawa z dnia 18 listopada 2020 r. o
            doręczeniach elektronicznych;
          </li>
        </ol>
      </Section>

      <Section title="Usługi oferowane na platformie Notaup.pl oraz ich dostawcy">
        <table>
          <thead>
            <tr>
              <th>Nazwa usługi</th>
              <th>Dostawca usługi</th>
              <th>Charakter usług</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Usługa identyfikacji tożsamości mObywatel</td>
              <td>Minister d/s Cyfryzacji</td>
              <td>Usługa bezpłatna</td>
            </tr>
            <tr>
              <td>Usługa wyszukiwania adresów podmiotów publicznych w BAE</td>
              <td>Minister d/s Cyfryzacji</td>
              <td>Usługa bezpłatna</td>
            </tr>
            <tr>
              <td>Publiczna Usługa Doręczenia Elektronicznego</td>
              <td>
                Operator Wyznaczony we współpracy z KFJ lub innym
                kwalifikowanym dostawcą usługi doręczenia elektronicznego
              </td>
              <td>Usługa bezpłatna</td>
            </tr>
            <tr>
              <td>Multi skrzynka, KFJ</td>
              <td>
                KFJ oraz inni kwalifikowani dostawcy usługi doręczenia
                elektronicznego
              </td>
              <td>Usługa bezpłatna</td>
            </tr>
            <tr>
              <td>Usługa KDE</td>
              <td>KFJ</td>
              <td>Usługa płatna</td>
            </tr>
            <tr>
              <td>Przesyłka Nota</td>
              <td>KFJ</td>
              <td>Usługa płatna</td>
            </tr>
            <tr>
              <td>EZD Nota</td>
              <td>KFJ</td>
              <td>Usługa płatna</td>
            </tr>
            <tr>
              <td>Rozszerzenia Nota, w tym Dysk szyfrowany Nota</td>
              <td>KFJ</td>
              <td>Usługi płatne</td>
            </tr>
          </tbody>
        </table>
      </Section>

      <Section title="Usługa KDE">
        <h3>Ogólne warunki korzystania z Usługi KDE</h3>
        <ol>
          <li>
            Warunkiem korzystania z usług określonych w Regulaminie przez
            nadawcę KURDE oraz adresata KURDE jest:
            <ol type="a">
              <li>zapoznanie się z Regulaminem i akceptacja Regulaminu;</li>
              <li>
                posiadanie ADE, utworzonego przez ministra właściwego do spraw
                informatyzacji;
              </li>
              <li>
                aktywacja skrzynki doręczeń, dokonywana przez dany podmiot;
              </li>
              <li>
                podanie adresu e-mail do notyfikacji podczas aktywacji skrzynki
                doręczeń.
              </li>
            </ol>
          </li>
          <li>
            Korzystanie z usług przez nadawcę KURDE oraz adresata KURDE jest
            możliwe po uprzednim uwierzytelnieniu się do systemu KURDE lub
            systemu kancelaryjnego.
          </li>
          <li>
            W procesie aktywacji skrzynki doręczeń podmiot jest zobowiązany
            podać adres e-mail do notyfikacji. Niepodanie adresu e-mail do
            notyfikacji skutkuje brakiem możliwości korzystania z usług.
          </li>
          <li>
            Adres e-mail do notyfikacji wykorzystywany jest do wysyłania przez
            KFJ w szczególności:
            <ol type="a">
              <li>regulaminu oraz zmian Regulaminu;</li>
              <li>
                polityki świadczenia usługi KDE oraz zmian Polityki świadczenia
                usługi KDE;
              </li>
              <li>
                informacji o oczekujących przesyłkach w ramach realizacji
                KURDE;
              </li>
              <li>
                innych informacji niezbędnych w procesie świadczenia usług.
              </li>
            </ol>
          </li>
          <li>
            Podmiot jest zobowiązany do niezwłocznego informowania o utracie
            dostępu lub zmianie adresu e-mail do notyfikacji.
          </li>
          <li>
            Odbiorca KURDE jest zobowiązany do przyjmowania informacji o
            oczekujących przesyłkach w ramach realizacji KURDE.
          </li>
          <li>
            Brak odbioru notyfikacji za pomocą adresu e-mail do notyfikacji nie
            stanowi podstawy do roszczeń lub braku skutecznego poinformowania o
            oczekujących przesyłkach w ramach realizacji KURDE.
          </li>
        </ol>

        <h3>Skrzynka do doręczeń elektronicznych</h3>
        <ol>
          <li>
            KFJ udostępnia skrzynki doręczeń elektronicznych służące do
            odbierania i wysyłania przesyłek.
          </li>
          <li>
            Dostęp do zasobów skrzynki doręczeń jest możliwy wyłącznie po
            wcześniejszym uwierzytelnieniu się na stronie notaup.pl.
          </li>
          <li>Gwarantowana pojemność skrzynki wynosi 3 GB.</li>
          <li>
            Do pojemności skrzynki doręczeń wlicza się:
            <ol type="a">
              <li>przesyłki wysłane;</li>
              <li>przesyłki odebrane w ramach realizacji KURDE;</li>
              <li>dowody.</li>
            </ol>
          </li>
          <li>
            Archiwizacja korespondencji polega na pobraniu ze skrzynki doręczeń
            przesyłki wraz z dowodami na dysk lokalny w postaci pliku
            elektronicznego w formacie .zip.
          </li>
          <li>
            Skrzynka doręczeń może przyjąć jeden z trzech statusów:
            <ol type="a">
              <li>
                gotowa do aktywacji – obejmujący okres od założenia przez KFJ
                skrzynki doręczeń do jej aktywacji przez podmiot;
              </li>
              <li>
                aktywna – nadawany przez KFJ niezwłocznie po aktywacji skrzynki
                doręczeń przez podmiot;
              </li>
              <li>
                tylko do odczytu – nadawany niezwłocznie po otrzymaniu przez
                KFJ informacji od ministra właściwego ds. informatyzacji o
                wykreśleniu ADE z BAE.
              </li>
            </ol>
          </li>
          <li>
            Po zapełnieniu 98% gwarantowanej pojemności skrzynki doręczeń
            Klient traci możliwość wysyłania i odbierania korespondencji do
            czasu usunięcia przez siebie zbędnych przesyłek.
          </li>
        </ol>

        <h3>Doręczanie przesyłek</h3>
        <ol>
          <li>
            Przesyłkę w ramach realizacji KURDE doręcza się adresatowi do
            skrzynki powiązanej z jego ADE.
          </li>
          <li>
            Przesyłkę w ramach realizacji KURDE uważa się za doręczoną:
            <ol type="a">
              <li>
                podmiotowi publicznemu – w chwili umieszczenia przesyłki w jego
                skrzynce;
              </li>
              <li>
                podmiotowi niepublicznemu:
                <ol type="i">
                  <li>w chwili odebrania przesyłki;</li>
                  <li>
                    w dniu następującym po 14 dniach od daty wskazanej w
                    dowodzie potwierdzającym wpłynięcie przesyłki do skrzynki –
                    w odniesieniu do przesyłek nadesłanych przez podmiot
                    publiczny [tzw. fikcja doręczenia].
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>

        <h3>Dowody doręczenia</h3>
        <ol>
          <li>
            Dowody potwierdzające poszczególne etapy świadczenia KURDE KFJ
            wystawia zgodnie z Polityką świadczenia usługi.
          </li>
          <li>
            Dowody dla KURDE wystawiane są w szczególności:
            <ol type="a">
              <li>w chwili nadania korespondencji – dowód wysłania;</li>
              <li>w chwili odebrania korespondencji – dowód otrzymania;</li>
              <li>
                w chwili wpłynięcia korespondencji na ADE podmiotu publicznego
                – dowód otrzymania;
              </li>
              <li>
                po upływie 14 dni od dnia wpłynięcia korespondencji przesłanej
                przez podmiot publiczny na adres do doręczeń elektronicznych
                podmiotu niepublicznego – dowód otrzymania.
              </li>
            </ol>
          </li>
          <li>
            Dowody wystawiane w ramach realizacji KURDE są przechowywane i
            udostępniane na żądanie adresata lub nadawcy przez 36 miesięcy od
            dnia ich wystawienia.
          </li>
        </ol>
      </Section>

      <Section title="Pozostałe usługi: Przesyłki Nota, EZD oraz Rozszerzenia Notaup.pl">
        <h3>Przesyłki szyfrowane Nota</h3>
        <ol>
          <li>
            Na platformie Notaup.pl działa kanał komunikacji elektronicznej
            obsługujący przesyłki z użyciem szyfrowania end-to-end działający
            pod nazwą Poczta Nota.
          </li>
          <li>Kanał obsługuje przesyłki szyfrowane Nota.</li>
          <li>Korzystanie z przesyłek szyfrowanych Nota jest odpłatne.</li>
          <li>
            Opłaty za obsługę przesyłek Nota mogą być naliczane w oparciu o dwa
            modele:
            <ol type="a">
              <li>osobno za każdą przesyłkę lub</li>
              <li>mogą być rozliczane w modelu ryczałtowym.</li>
            </ol>
          </li>
          <li>
            Aktualna wysokość opłaty jednorazowej oraz opłaty ryczałtowej są
            zawarte w cenniku dostępnym na stronie notaup.pl.
          </li>
          <li>
            Co do zasady opłatę za obsługę przesyłek Nota pobiera się od
            nadawcy przesyłki.
          </li>
        </ol>

        <h3>Usługa EZD oraz Rozszerzenia Notaup.pl</h3>
        <ol>
          <li>
            Usługa EZD wykonywana jest w oparciu o oprogramowanie służące do
            elektronicznego zarządzania dokumentami.
          </li>
          <li>
            Rozszerzenia Notaup.pl są to usługi dodatkowe wykonywane w oparciu
            o oprogramowanie rozbudowujące możliwości funkcjonalne platformy
            Notaup.pl.
          </li>
          <li>
            Usługa EZD oraz Rozszerzenia Notaup.pl są udostępniane na
            platformie Notaup.pl w modelu SaaS.
          </li>
          <li>
            Usługa EZD oraz Rozszerzenia Notaup.pl są udostępniane jako usługi
            płatne.
          </li>
          <li>
            Usługa EZD oraz Rozszerzenia Notaup.pl są aktywowane samodzielnie
            przez Klienta.
          </li>
          <li>
            Aktywowanie usług odbywa się bezpośrednio na platformie Notaup.pl,
            w module Ustawienia.
          </li>
          <li>Usługi mogą być dezaktywowane w dowolnym momencie.</li>
          <li>
            Dezaktywowana usługa zostanie wyłączona z końcem miesiąca
            kalendarzowego, w którym zostanie dezaktywowana.
          </li>
        </ol>
      </Section>

      <Section title="Rozliczenie usług oraz pobieranie opłat">
        <ol>
          <li>
            Przesyłki typu Doręczenia elektroniczne, przesyłki Nota, usługa EZD
            oraz Rozszerzenia Notaup.pl udostępniane są odpłatnie.
          </li>
          <li>
            Opłaty za obsługę przesyłek Nota mogą być naliczane w oparciu o dwa
            modele:
            <ol type="a">
              <li>osobno za każdą przesyłkę lub</li>
              <li>mogą być rozliczane w modelu ryczałtowym.</li>
            </ol>
          </li>
          <li>
            Opłaty za usługę EZD oraz Rozszerzenia Notaup.pl są naliczane w
            formie ryczałtowej.
          </li>
          <li>
            Aktualne opłaty są zawarte w cenniku dostępnym na stronie notaup.pl.
          </li>
          <li>Okresem rozliczeniowym jest miesiąc kalendarzowy.</li>
          <li>
            Łączna kwota opłat za dany okres rozrachunkowy będzie wskazana w
            fakturze wystawianej w pierwszym dniu roboczym nowego okresu
            rozrachunkowego.
          </li>
          <li>
            Opłata widniejąca na fakturze będzie pobierana za pomocą usługi
            płatniczej o nazwie „Płatności cykliczne".
          </li>
        </ol>
      </Section>

      <Section title="Odpowiedzialność">
        <ol>
          <li>
            Do odpowiedzialności KFJ za niewykonanie lub nienależyte wykonanie
            usług stosuje się ustawę z dnia 23 kwietnia 1964 r. – Kodeks
            cywilny.
          </li>
          <li>
            KFJ odpowiada za niewykonanie lub nienależyte wykonanie KURDE,
            chyba że niewykonanie lub nienależyte wykonanie nastąpiło:
            <ol type="a">
              <li>wskutek siły wyższej;</li>
              <li>
                z przyczyn występujących po stronie nadawcy lub adresata,
                niewywołanych winą KFJ;
              </li>
              <li>
                z powodu naruszenia przez nadawcę lub adresata przepisów ustawy
                UoDE albo zasad określonych w Regulaminie.
              </li>
            </ol>
          </li>
          <li>
            Za niewykonanie KURDE uważa się brak możliwości zapoznania się
            przez adresata z treścią wysłanych danych po upływie 24 godzin od
            chwili ich wysłania, z przyczyn leżących po stronie KFJ.
          </li>
          <li>
            Z tytułu niewykonania KURDE przysługuje odszkodowanie w wysokości
            dwukrotności najwyższej opłaty za taką usługę. W przypadku
            niewykonania KURDE, KFJ zwraca w całości pobraną opłatę.
          </li>
        </ol>
      </Section>

      <Section title="Niedozwolone praktyki">
        <ol>
          <li>
            Klient nie może używać sprzętu lub oprogramowania mogącego
            uszkodzić lub zakłócić prawidłowe funkcjonowanie platformy
            Notaup.pl, ani służącego do przechwytywania danych ze strony
            internetowej notaup.pl.
          </li>
          <li>
            Klient nie może podejmować żadnych działań powodujących
            nieuzasadnione obciążenie w sieci internetowej lub infrastruktury
            należącej do KFJ.
          </li>
        </ol>
      </Section>

      <Section title="Postępowanie reklamacyjne">
        <ol>
          <li>
            Reklamację z tytułu niewykonania KURDE można złożyć najwcześniej w
            dniu następującym po dniu, w którym upłynęły 24 godziny od chwili
            wysłania danych, potwierdzonego dowodem wysłania.
          </li>
          <li>
            Reklamację wniesioną z tytułu niewykonania KURDE po upływie 12
            miesięcy od dnia nadania korespondencji pozostawia się bez
            rozpoznania.
          </li>
          <li>
            Reklamacja powinna zawierać:
            <ol type="a">
              <li>imię i nazwisko reklamującego lub jego nazwę lub firmę;</li>
              <li>
                adres do korespondencji lub adres siedziby reklamującego oraz
                jego adres do doręczeń elektronicznych;
              </li>
              <li>adres poczty elektronicznej reklamującego;</li>
              <li>datę sporządzenia reklamacji;</li>
              <li>przedmiot reklamacji;</li>
              <li>datę nadania przesyłki, której dotyczy reklamacja;</li>
              <li>numer przesyłki, której dotyczy reklamacja;</li>
              <li>uzasadnienie reklamacji;</li>
              <li>żądaną kwotę odszkodowania;</li>
              <li>potwierdzenie nadania przesyłki;</li>
              <li>wykaz załączonych dokumentów.</li>
            </ol>
          </li>
          <li>
            Odszkodowanie wypłaca się zgodnie z dyspozycją reklamującego w
            terminie nie dłuższym niż 30 dni od daty wydania decyzji
            przyznającej odszkodowanie.
          </li>
        </ol>
      </Section>

      <Section title="Dane osobowe">
        <ol>
          <li>
            Administratorem danych osobowych osób fizycznych korzystających z
            usług przewidzianych w Regulaminie jest KFJ Inwestycje Sp. z o.o. z
            siedzibą w Sopocie 81-807 przy ulicy 1 Maja 5.
          </li>
          <li>
            Kontakt z Inspektorem ochrony danych: Inspektor ochrony danych KFJ
            Inwestycje Sp. z o.o., ul. 1 Maja 5, 81-807 Sopot, e-mail:{" "}
            <a href="mailto:iod@doreczeniaelektroniczne.pl">
              iod@doreczeniaelektroniczne.pl
            </a>
            .
          </li>
          <li>
            Dane osobowe są przetwarzane na podstawie art. 6 ust. 1 lit. b i
            lit. c RODO – w celu realizacji usług, o których mowa w
            Regulaminie.
          </li>
          <li>
            Osobom, których dane dotyczą, przysługuje prawo dostępu do danych
            osobowych, ich sprostowania, usunięcia, ograniczenia przetwarzania
            oraz przenoszenia danych.
          </li>
          <li>
            Osobom, których dane dotyczą, przysługuje prawo wniesienia skargi
            do Prezesa Urzędu Ochrony Danych Osobowych.
          </li>
        </ol>
      </Section>

      <Section title="Postanowienia końcowe">
        <ol>
          <li>
            KFJ ma prawo odmówić realizacji usługi, jeśli nie spełnia ona
            warunków określonych w Regulaminie.
          </li>
          <li>Praktyki Usługi są niedyskryminacyjne.</li>
          <li>
            Tam, gdzie jest to wykonalne, Usługa jest przystępna dla osób
            niepełnosprawnych. KFJ wzięło pod uwagę standard ETSI EN 301 549.
          </li>
          <li>
            O dacie wejścia w życie zmiany do Regulaminu oraz o zakresie zmian
            Regulaminu KFJ informuje za pośrednictwem poczty elektronicznej.
          </li>
          <li>
            W sprawach nieuregulowanych Regulaminem mają zastosowanie przepisy
            prawa powszechnie obowiązującego.
          </li>
          <li>
            Wszelkie spory wynikłe między KFJ a Klientem zostaną poddane pod
            rozstrzygnięcie sądu powszechnego miejscowo właściwego dla siedziby
            KFJ.
          </li>
          <li>
            Wszelkie skargi, reklamacje czy uwagi prosimy zgłaszać pisemnie:
            <ol type="a">
              <li>Adres korespondencyjny: ul. 1 Maja 5, 81-807 Sopot</li>
              <li>
                Adres mailowy:{" "}
                <a href="mailto:kontakt@notaup.pl">kontakt@notaup.pl</a>
              </li>
            </ol>
          </li>
        </ol>
      </Section>
    </LegalPage>
  );
}

export default Regulamin;
